const loadingLabel = "Cargando";
const esCL = {
  loadingLabel
};
export {
  esCL as default,
  loadingLabel
};
